import Button from "Components/shared/button";
import Text from "Components/shared/text";
import React from "react";
import { DebitCardHomeHeader } from "./DebitCardHomeHeader";
import { DebitCardInProcess } from "./DebitCardInProcess";

export const DebitCardHomeContent = () => {
  return (
    <div>
      {/* <DebitCardInProcess /> //TODO how to know its in Process */}
      <DebitCardHomeHeader />
    </div>
  );
};
